import React from 'react';
import PropTypes from 'prop-types';
import QueryComponent from '@skooldio/skooldio-graphql-utils/dist/QueryComponent';

import { getMyExternalProfileInfo } from 'GraphQL/query/MyProfile.query';
import { getCourseSearchByProviderName } from 'Util/classroomProviderUtils';
import { useSearchMyCourseProvider } from 'Context/SearchMyCourseProvider';
import { useMyCoursesTracking } from 'Util/Analytics';

import SearchSuggestionView from './SearchSuggestion';

const SearchSuggestion = ({
  onHandleCloseSearchSuggestion,
  searchHistoryLists,
  saveSearchHistoryLists,
  ...props
}) => {
  const { updateSearchTerm } = useSearchMyCourseProvider();
  const { logCourseSearch } = useMyCoursesTracking();

  return (
    <QueryComponent query={getMyExternalProfileInfo}>
      {({ myExternalProfile }) => {
        const { providerName } = myExternalProfile || {};
        const courseSearchData = getCourseSearchByProviderName(providerName);
        const searchItems = courseSearchData?.searchItems ?? [];

        return (
          <SearchSuggestionView
            searchItems={searchItems}
            onHandleCloseSearchSuggestion={onHandleCloseSearchSuggestion}
            searchHistoryLists={searchHistoryLists}
            saveSearchHistoryLists={saveSearchHistoryLists}
            updateSearchTerm={updateSearchTerm}
            logCourseSearch={logCourseSearch}
            {...props}
          />
        );
      }}
    </QueryComponent>
  );
};

SearchSuggestion.propTypes = {
  searchHistoryLists: PropTypes.array,
  onHandleCloseSearchSuggestion: PropTypes.func,
  saveSearchHistoryLists: PropTypes.func,
};

export default SearchSuggestion;
